export { default } from './NewsIcon';
